<template lang="pug">
#yp
	YourPlanAddCourses(
		v-if="showAddCourses"
		:sectionInfo="selectedSubjectCard"
		@done="toggleModal( 'showAddCourses', false )"
	)
	template(v-else)
		.top-bar
			.icon.icon-toggle( @click='toggleMenu' )
			profile-image(
				class="profile-image"
				@profile-click="openUser"
				@feedback-click="giveFeedback"
			)
			.headers
				h1.main-header Your Plan
				h2.chosen-program {{ chosenProgramText }}
			//- topbar tabs
			//- .pos-wrapper.easy-scroll.swipper-no-swiping
			//- 	.poss
			//- 		.pos(class="active") {{ chosenProgramText }}
		.page
			//- Only displayed when printing
			.print-header-container
				.print-title Your Plan
				.print-chosen-program {{ chosenProgramText }}
			//- loading animation
			.loading-circles(v-if="loadingPlan || loadingUser")
				span
				span
				span
			template(v-else-if="chosenProgram && studentPlan")
				.top(v-if="chosenProgram")
					.top-wrapper
						.left-container
							.legend
								.legend-item
									.legend-color.requiredSection *
									.legend-text Required
								.legend-item
									.legend-color.two-courses-required †
									.legend-text Two Courses Required
						GradReqsCheck( @click="showGradReqsModal" :key="gradReqsCheckKey" )
						.right-container
							DownloadLink(@click="downloadPlan")
							.info-link(@click="toggleInfoModal( 'open' )")
								p.info-text What is this?
								svg.question-mark(viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg')
									path(d='M5.40726 7.94302C5.40726 7.43664 5.46449 7.03778 5.57894 6.74644C5.6934 6.45163 5.87895 6.19671 6.13561 5.98167C6.39227 5.76663 6.5865 5.57067 6.7183 5.39378C6.85356 5.21343 6.92119 5.01574 6.92119 4.8007C6.92119 4.27698 6.69575 4.01512 6.24487 4.01512C6.03676 4.01512 5.86855 4.09142 5.74022 4.24403C5.61189 4.39663 5.54426 4.603 5.53732 4.86313H3.77887C3.78581 4.16946 4.00431 3.63013 4.43439 3.24514C4.86446 2.85669 5.46796 2.66246 6.24487 2.66246C7.01831 2.66246 7.6166 2.84108 8.03974 3.19832C8.46634 3.55556 8.67965 4.06367 8.67965 4.72266C8.67965 5.01053 8.62242 5.27239 8.50796 5.50824C8.39351 5.74409 8.20969 5.98514 7.9565 6.23139L7.3582 6.78806C7.18826 6.95107 7.07033 7.11929 7.00443 7.29271C6.93854 7.46266 6.90212 7.67943 6.89518 7.94302H5.40726ZM5.19396 9.52459C5.19396 9.26793 5.28587 9.0581 5.46969 8.89508C5.65698 8.7286 5.88936 8.64536 6.16683 8.64536C6.4443 8.64536 6.67494 8.7286 6.85876 8.89508C7.04605 9.0581 7.1397 9.26793 7.1397 9.52459C7.1397 9.78125 7.04605 9.99282 6.85876 10.1593C6.67494 10.3223 6.4443 10.4038 6.16683 10.4038C5.88936 10.4038 5.65698 10.3223 5.46969 10.1593C5.28587 9.99282 5.19396 9.78125 5.19396 9.52459Z' fill='#4F4F4F')
									path(fill-rule='evenodd' clip-rule='evenodd' d='M6.39286 11.4695C9.19664 11.4695 11.4695 9.19664 11.4695 6.39286C11.4695 3.58909 9.19664 1.31618 6.39286 1.31618C3.58909 1.31618 1.31618 3.58909 1.31618 6.39286C1.31618 9.19664 3.58909 11.4695 6.39286 11.4695ZM6.39286 12.7857C9.92354 12.7857 12.7857 9.92354 12.7857 6.39286C12.7857 2.86218 9.92354 0 6.39286 0C2.86218 0 0 2.86218 0 6.39286C0 9.92354 2.86218 12.7857 6.39286 12.7857Z' fill='#4F4F4F')
				YourPlanContent(
					class="your-plan-content"
					:studentPlan="studentPlan"
					@selectSection="onSelectSection"
				)
			.emptyContainer(v-else-if="!chosenProgram")
				.emptyWrapper
					img(:src="emptyBox")
					.message Looks like you still need to choose your Program of Study
					.button(@click="routeTo( 'program-of-study' )") Select Program of Study
	Transition(name='modal-fade')
		YourPlanModal(
			v-if="showSubjectCardModal && !showAddCourses"
			class="your-plan-modal"
			:sectionInfo="selectedSubjectCard"
			@close="toggleModal( 'showSubjectCardModal', false )"
			@addCourse="startAddCourseFlow"
			@changeGradCredit="onChangeGradCredit"
			@changeYear="onChangeYear"
		)
	AlertModal(
		class="alert-modal"
		:isOpen="showSubjectAlertModal"
		:message="'Changing the subject will remove the following courses from your plan. You can still find these courses in the All Saved Courses tab.'"
		:items="coursesToBeRemovedNames"
		@cancel="toggleModal( 'showSubjectAlertModal', false )"
		@accept="acceptGradCreditChange"
	)
	AlertModal(
		class="alert-modal"
		:isOpen="showYearAlertModal"
		:message="'Changing the year will result in the following changes. Your added courses will still be saved in each card.'"
		:items="yearChangeItems"
		@cancel="toggleModal( 'showYearAlertModal', false )"
		@accept="acceptChangeYear"
	)
	Transition(name='modal-fade')
		BaseModal.infoModal(v-if="showInfoModal" @backdropClick="toggleInfoModal")
			template(v-slot:body)
				.top
					h2.title What is&nbsp
						span Your Plan
						| ?
					IconClose.icon-close(@click="toggleInfoModal")
				.bottom
					p.sentence Your Plan generates a&nbsp
						span 4-year high school outline based on your chosen Program of Study
						| . You can change your Program of Study at any time.
					h3.sectionTitle Subjects
					p.sentence Each card represents the course that will be taken in that year. You can add courses you're interested in taking that fall under that subject. You can change the subject of cards without a red asterisk. To view the courses already added, or to add/delete courses, click on any card.
					h3.sectionTitle Required Subjects
						span.symbol *
					p.sentence Subject cards with a red asterisk represent subjects that are required to fulfill graduation requirements.
					h3.sectionTitle Two Courses Required
						span.symbol.dagger †
					p.sentence Subject cards with a blue dagger represent subjects that require two courses to fulfill graduation requirements.
	Transition(name="modal-fade")
		BaseModal.reqsModal( v-if="showReqsModal" @backdropClick="toggleModal( 'showReqsModal', false )" )
			template( v-slot:header )
				h2.title Graduation Requirements
				.legend
					.legend-item
						IconAlert.legend-color.requiredIcon
						.legend-text Not Met
					.legend-item
						.legend-color.check.saved
						.legend-text Met
				IconClose.icon-close( @click="toggleModal( 'showReqsModal', false )" )
			template( v-slot:body )
				.grad-reqs-body
					.grad-reqs-section( v-for="( value, key, i ) in remainingReqs" :key="key + i" )
						.gradCreds(v-if="key === 'gradCredits'")
							.grad-reqs-card( v-for="( rValue, rKey, r ) in value" :key="rKey + r" :class="{ 'reqs-met': rValue.yearsNeeded === 0 }" )
								IconAlert.requiredIcon.reqsIcon(v-if="rValue.yearsNeeded > 0")
								.check.saved.reqsIcon(v-else)
								.grad-reqs-title
									p.title {{ rValue.req.slice( 1 ).replaceAll( '-', ' ' ) }} :&nbsp
										span.years-remain {{ rValue.yearsNeeded > 0 ? `${rValue.yearsNeeded} years remaining to be planned` : 'Requirements have been met!' }}
						.courses(v-else-if="key === 'courses'")
							.grad-reqs-card( v-for="( cValue, cKey, c ) in value" :key="cKey + c" :class="{ 'reqs-met': cValue.completed }")
								IconAlert.requiredIcon.reqsIcon(v-if="!cValue.completed")
								.check.saved.reqsIcon(v-else)
								.grad-reqs-title
									p.title {{ cValue.class }} :&nbsp
										span.years-remain {{ cValue.completed ? "Requirements have been met!" : "Course has not been planned." }}
						.years(v-else)
							.grad-reqs-card( v-for="( yValue, yKey, y ) in value" :key="yKey + y" :class="{ 'reqs-met': yValue.coursesNeeded === 0 }" )
								IconAlert.requiredIcon.reqsIcon(v-if="yValue.coursesNeeded > 0")
								.check.saved.reqsIcon(v-else)
								.grad-reqs-title
									p.title {{ yValue.year }} :&nbsp
										span.years-remain {{ yValue.coursesNeeded > 0 ? `${yValue.coursesNeeded} more ${yValue.coursesNeeded > 1 ? 'course' : 'courses' } needed` : 'Number of courses required met.' }}
						hr.divider
</template>

<script>
// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
import emptyBox from '@/assets/empty_box.png';
import ProfileImage from '@/components/ProfileImage';
import BaseModal from '@/components/BaseModal';
import AlertModal from '@/components/AlertModal';
import DownloadLink from '@/components/DownloadLink';
import YourPlanContent from '@/components/YourPlanContent';
import YourPlanModal from '@/components/YourPlanModal';
import YourPlanAddCourses from '@/components/YourPlanAddCourses';
import GradReqsCheck from '@/components/GradReqsCheck';
import IconClose from '@/components/IconClose';
import IconAlert from '@/components/IconAlert';
import { PrintPlan } from '@/lib/API';

export default {
  name       : 'your-plan',
  components : {
    ProfileImage,
    IconClose,
    IconAlert,
    DownloadLink,
    BaseModal,
    AlertModal,
    GradReqsCheck,
    YourPlanContent,
    YourPlanModal,
    YourPlanAddCourses
  },

  data : () => ( {
    emptyBox,
    showInfoModal : false,

    // Object of the form { year: string; index: number; }
    // Points to a specific entry in studentPlan
    selectedSubjectCard : null,

    showSubjectCardModal  : false,
    showAddCourses        : false,
    showSubjectAlertModal : false,
    showYearAlertModal    : false,
    showReqsModal         : false,

    // Tracks which courses to pass to the alert modal when the user
    // attemps to change the grad credit for a given section
    // Array of course objects
    coursesToBeRemoved : [],

    // Tracks what actions are being taken when moving a class from
    // one year to another, to pass directly to the year change AlertModal
    // Array of strings
    yearChangeItems : [],

    // Required for the change subject alert modal flow, when the user is trying
    // to change the grad credit for a given class
    tentativeGradCredit : null,

    // Required for the change year alert modal flow, object with properties targetYear and
    // targetIndex
    tentativeSectionTarget : {},

    // Tracks the remaining graduation requirements
    remainingReqs    : { gradCredits : [], courses : [], years : [] },
    gradReqsCheckKey : 0
  } ),

  computed : {
    loadingUser() {
      return this.$store.getters.loadingUser;
    },
    loadingPlan() {
      return this.$store.getters.loadingStudentPlan;
    },

    chosenProgram() {
      return this.$store.getters.chosenProgram;
    },

    chosenProgramText() {
      if ( this.chosenProgram ) {
        const pathway = this.$store.getters.getCTEPathwayByID( this.chosenProgram );
        return pathway ? pathway.name : '';
      }
      return 'No Program of Study Selected';
    },

    studentPlan() {
      return this.$store.getters.studentPlan;
    },

    // Returns the section that this.selectedSubjectCard points to
    selectedSection() {
      if ( this.selectedSubjectCard ) {
        const { year, index } = this.selectedSubjectCard;
        return this.$store.getters.studentPlan[year][index];
      }
      return null;
    },

    coursesToBeRemovedNames() {
      return this.coursesToBeRemoved.map( course => course.name );
    }
  },

  mounted() {
    // setTimeout(() => console.log('sections:', this.$store.getters.studentPlanSections), 1000);
  },

  methods : {
    toggleModal( modal, state ) {
      this[modal] = state;
      this.updateGradReqsCheckKey();
    },
    openUser() {
      this.$store.dispatch( 'updateStore', ['userSwiperState', 'open'] );
    },
    toggleMenu() {
      this.$store.dispatch( 'toggleSideMenu' );
    },
    giveFeedback() {
      // eslint-disable-next-line no-undef
      SpacebarFeedback.open();
    },
    routeTo( route ) {
      this.$router.push( route ).catch( () => {} );
    },
    toggleInfoModal( state = 'close' ) {
      this.showInfoModal = state === 'open';
    },

    async downloadPlan() {
      try {
        const res = await PrintPlan();
        const blob = await res.blob();
        const link = document.createElement( 'a' );
        link.href = window.URL.createObjectURL( blob );
        link.download = 'Your-Plan.pdf';
        link.click();
        window.URL.revokeObjectURL( link.href );
      }
      catch ( err ) {
        console.error( 'Error', err );
      }

      // Create a non-reactive student plan object with all course objects joined
      // const studentPlan = JSON.parse( JSON.stringify( this.$store.getters.studentPlan ) );
      // Object.entries( studentPlan ).forEach( ( [, sections] ) => {
      // 	sections.forEach( ( section ) => {
      // 		if ( !section.courses ) return;
      // 		section.courses = section.courses
      // 			.map( id => this.$store.getters.getCourseByID( id ) )
      // 			.filter( course => !!course );
      // 	} );
      // } );

      // const getSectionsContent = ( sectionTitle, key ) => {
      // 	const title = { text : sectionTitle, margin : [0, 20, 0, 0], style : 'h2' };
      // 	const items = studentPlan[key].map( ( section ) => {
      // 		const sectionContent = [{ text : section.label, margin : [8, 10, 0, 0], style : 'h3' }];
      // 		let sectionItems = { text : 'No courses selected', margin : [24, 4, 0, 0] };
      // 		if ( section.courses && section.courses.length > 0 ) {
      // 			sectionItems = {
      // 				ul : section.courses.map( course => ( {
      // 					text   : course.name,
      // 					// left top right bottom margin
      // 					margin : [24, 4, 0, 0]
      // 				} ) )
      // 			};
      // 		}
      // 		return sectionContent.concat( sectionItems );
      // 	} );
      // 	return [title].concat( items );
      // };

      // pdfMake.vfs = pdfFonts.pdfMake.vfs;

      // const content = [
      // 	{ text : 'Your Plan', style : 'h1' },
      // ].concat(
      // 	getSectionsContent( 'Freshman Year', 'freshman' ), getSectionsContent( 'Sophomore Year', 'sophomore' ),
      // 	getSectionsContent( 'Junior Year', 'junior' ), getSectionsContent( 'Senior Year', 'senior' )
      // );
      // const docDefinition = {
      // 	content,
      // 	styles : {
      // 		h1 : {
      // 			fontSize  : 24,
      // 			bold      : true,
      // 			alignment : 'center'
      // 		},
      // 		h2 : {
      // 			fontSize : 20,
      // 			bold     : true
      // 		},
      // 		h3 : {
      // 			fontSize : 14,
      // 			// bold     : true
      // 		}
      // 	}
      // };
      // pdfMake.createPdf( docDefinition ).download( 'Your Plan' );
    },

    /**
		 * Executes whenever the user selects a subject card (e.g., Senior English). Displays the YourPlan modal.
		 *
		 * @param {object} sectionInfo References a specific section in this.studentPlan. Is an
		 * object of the form: { year: string; index: number; section: object }
		 */
    onSelectSection( sectionInfo ) {
      this.selectedSubjectCard = sectionInfo;
      this.toggleModal( 'showSubjectCardModal', true );
      this.updateGradReqsCheckKey();
    },

    startAddCourseFlow() {
      // this.showSubjectCardModal = false;
      this.toggleModal( 'showAddCourses', true );
      this.updateGradReqsCheckKey();
    },

    /**
		 * Displays an alert modal if changing the grad credit will alter the user's planned courses. Otherwise,
		 * just directly changes the grad credit
		 *
		 * @param {object} newGradCredit Grad credit object that should replace this.selectedSubjectCard's current grad credit(s)
		 */
    onChangeGradCredit( newGradCredit ) {
      // First, check if theres any difference to the new grad credit and the current grad credits.
      // Note that selectedSection.gradCredits may be undefined since "No Course Required" has no grad credits, and
      // firebase doesn't track empty arrays!
      const gradCreditsDidntChange = ( this.selectedSection.gradCredits || [] )
        .map( gc => gc === newGradCredit.id )
        .reduce( ( acc, curr ) => acc && !!curr, true );
      if ( this.selectedSection.gradCredits instanceof Array && gradCreditsDidntChange ) {
        return;
      }

      // console.log( 'changing to gc', newGradCredit, this.selectedSubjectCard );
      const selectedSectionCourses = this.selectedSection.courses || [];

      // Find all courses in the current section's gradCredits that do not include the
      // newly selected grad credit
      const currentCourses = selectedSectionCourses
        .map( courseID => this.$store.getters.getCourseByID( courseID ) )
        .filter( course => !!course );
      const coursesToRemove = currentCourses
        .filter( course => !course.gradCredits.includes( newGradCredit.id ) );
      // console.log( 'Need to remove:', coursesToRemove );

      if ( coursesToRemove.length > 0 ) {
        this.toggleModal( 'showSubjectAlertModal', true );
        this.coursesToBeRemoved = coursesToRemove;
        this.tentativeGradCredit = newGradCredit;
        return;
      }

      const keptCourses = currentCourses.filter( c => !coursesToRemove.find( cr => cr.id === c.id ) );
      this.changeGradCredit( newGradCredit, keptCourses );
      this.updateGradReqsCheckKey();
    },

    acceptGradCreditChange() {
      this.toggleModal( 'showSubjectAlertModal', false );
      const currentCourses = this.selectedSection.courses || [];
      const keptCourses = currentCourses.filter( cID => !this.coursesToBeRemoved.find( c => c.id === cID ) );
      this.changeGradCredit( this.tentativeGradCredit, keptCourses );
      this.updateGradReqsCheckKey();
    },

    changeGradCredit( newGradCredit, courses ) {
      const { year, index } = this.selectedSubjectCard;
      this.$store.dispatch( 'changeStudentPlanSubject', {
        year, index, gradCredit : newGradCredit, courses    : courses.map( c => c.id )
      } );
      this.toggleModal( 'showSubjectAlertModal', false );
      this.updateGradReqsCheckKey();
      // this.showSubjectCardModal = false;
    },

    onChangeYear( targetYear ) {
      const { year: currYear, index: currIndex } = this.selectedSubjectCard;
      let targetIndex = this.studentPlan[targetYear].findIndex( section => !section.gradCredits );

      // Check if target year has an open slot, thus no need to display the alert modal
      if ( targetIndex !== -1 ) {
        this.$store.dispatch( 'swapStudentPlanSubjects', {
          currYear,
          currIndex,
          targetYear,
          targetIndex
        } );
        this.toggleModal( 'showSubjectCardModal', false );
        return;
      }

      // Otherwise, select the last section
      targetIndex = 6;

      const capitalize = string => string.charAt( 0 ).toUpperCase() + string.slice( 1 ).toLowerCase();

      const currSection = this.studentPlan[currYear][currIndex];
      const targetSection = this.studentPlan[targetYear][targetIndex];
      this.yearChangeItems = [
        // If moving a blank subject, add special text
        `Moving ${currSection.label || 'an unselected subject'} to ${capitalize( targetYear )} year`,
        `Moving ${targetSection.label} to ${capitalize( currYear )} year`
      ];
      this.tentativeSectionTarget = { targetYear, targetIndex };
      this.toggleModal( 'showYearAlertModal', true );
      this.updateGradReqsCheckKey();
    },

    acceptChangeYear() {
      const { year: currYear, index: currIndex } = this.selectedSubjectCard;
      const { targetYear, targetIndex } = this.tentativeSectionTarget;
      this.$store.dispatch( 'swapStudentPlanSubjects', {
        currYear, currIndex, targetYear, targetIndex
      } );
      this.toggleModal( 'showYearAlertModal', false );
      this.toggleModal( 'showSubjectCardModal', false );
      this.updateGradReqsCheckKey();
    },

    showGradReqsModal( r ) {
      this.remainingReqs = r;
      this.toggleModal( 'showReqsModal', true );
      this.updateGradReqsCheckKey();
    },

    updateGradReqsCheckKey() {
      this.gradReqsCheckKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
#yp {
	height: 100vh;
	overflow: hidden;
	background: white;
	opacity: 0.999;
	display: flex;
	flex-direction: column;

	.your-plan-modal {
		z-index: 10;
	}

	.alert-modal {
		z-index: 11;
	}

	.top-bar {
		position: relative;
		height: 115px;
		box-shadow: $floatingObject;
		padding-top: 10px;
		align-items: center;
		justify-content: flex-end;
		position: relative;
		background: white;
		z-index: 10;

		.icon-toggle {
			position: absolute;
			left: 15px;
		}

		.profile-image {
			position: absolute;
			right: 10px;
			top: 10px;
		}

		.headers {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			padding-top: 5px;

			.main-header {
				font-size: 24px;
				color: $primary;
				font-weight: 600;
				text-align: center;
			}

			.chosen-program {
				font-size: 16px;
				font-weight: 500;
				border-bottom: 2px solid $primary;
				padding: 5px 10px;
				color: $primary;
			}
		}
	}

	.page {
		flex: 1;
		height: 100%;
		overflow: auto;
		padding: 30px;

		.print-header-container {
			display: none;
		}

		// .your-plan-content {
		// 	// margin-bottom: 100px;
		// }

		.emptyContainer {
			height: 100%;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			.emptyWrapper {
				height: 60%;
				width: 66%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-direction: column;
				.message {
					font-weight: 600;
					font-size: 16px;
					line-height: 145%;
					letter-spacing: -.03em;
					color: $ypText;
					text-align: center;
					width: 40%;
				}
			}
		}

		.top {
			width: 100%;
			margin-bottom: 30px;
			overflow: visible;
			background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 49.48%);
			.top-wrapper {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.left-container {
					display: flex;
					align-items: flex-start;
					flex-direction: column;
					.legend {
						display: flex;
						align-items: center;
						justify-content: flex-start;
						.legend-item {
							display: flex;
							align-items: center;
							margin-right: 50px;
							.legend-color {
								width: 20px;
								height: 20px;
								margin-right: -9px;
								margin-top: -10px;
								&.requiredSection {
									color: $close;
								}
								&.two-courses-required {
									color: #07566F;
								}
							}
							.legend-text {
								font-size: 12px;
								font-weight: 400;
								font-style: italic;
								line-height: 16px;
								letter-spacing: -0.03em;
								color: #757575;
							}
						}
					}
				}
				.right-container {
					display: flex;
					flex-direction: column-reverse;
					align-items: center;
					margin-left: 50px;
					@include md {
						flex-direction: row;
					}

					.info-link {
						margin-left: 30px;
						font-size: 12px;
						font-weight: 500;
						line-height: 16px;
						letter-spacing: -0.03em;
						color: $ypText;
						cursor: pointer;
						display: flex;
						align-items: center;
						.question-mark {
							flex-shrink: 0;
							margin-left: 8px;
							width: 16px;
							height: 16px;
						}
					}
				}
				@media only screen and (max-width: 991px) {
					flex-direction: column;
					gap: 20px;
					.right-container {
						flex-direction: row;
						margin-left: unset;
					}
				}
			}
		}
	}
}

.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
	&::v-deep .modal {
		transform: translateY( 50vh );
	}
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.3s ease;
	&::v-deep .modal {
		transition: transform 0.3s ease;
	}
}

.infoModal {
	z-index: 15;

	&::v-deep .modal {
		width: 90%;
		max-height: 90vh;

		@include sm {
			width: 55%;
		}
		.modal-body {
			height: 100%;
			width: 100%;
			padding: 25px 25px 25px 40px;
			.top {
				display: flex;
				align-items: center;
				justify-content: space-between;
				h2.title {
					font-family: 'Work Sans', sans-serif;
					font-weight: 600;
					font-size: 24px;
					line-height: 21px;
					letter-spacing: -0.05em;
					color: #36548D;
					cursor: default;
					span {
						text-decoration: underline;
					}
				}
				.icon-close {
					color: $close;
				}
			}
			.bottom {
				margin-top: 30px;
				width: 90%;
				.sectionTitle {
					font-weight: 700;
					font-size: 18px;
					font-family: 'Work Sans', sans-serif;
					text-transform: uppercase;
					line-height: 23px;
					letter-spacing: -0.03em;
					margin-bottom: 10px;
					cursor: default;
					.symbol {
						margin-left: 6px;
						color: $close;
						&.dagger {
							color: #07566F !important;
						}
					}
				}
				.sentence {
					font-weight: 500;
					font-size: 15px;
					line-height: 26px;
					letter-spacing: -0.03em;
					color: $ypText;
					margin-bottom: 20px;
					cursor: default;
					span {
						color: #2668D0;
						font-weight: 600;
					}
				}
			}
		}
	}
}

.reqsModal {
  z-index: 15;
  &::v-deep .modal {
		width: 90%;
		max-height: 90vh;

    @include sm {
      width: 55%;
    }
    .modal-header {
			height: 33%;
			padding: 19px 25px;
      .title {
				text-align: center;
				padding: 25px 0;
      }
      .legend {
				display: flex;
				align-items: center;
				justify-content: space-evenly;
				width: 66%;
				margin: auto;
        .legend-item {
					display: flex;
					align-items: center;
					justify-content: space-evenly;
					.legend-color {
						margin-right: 7%;
						width: 30px;
						height: 30px;
						pointer-events: none;
						flex-shrink: 0;
					}
          .legend-text {
						white-space: nowrap;
          }
        }
      }
      .icon-close {
        position: absolute;
				color: $close;
        top: 8px;
        right: 8px;
      }
    }
    .modal-body {
			height: 67%;
      padding: 40px 0;
			overflow: auto;
      .grad-reqs-body {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
        .grad-reqs-section {
					width: 68%;
          .grad-reqs-card {
						display: flex;
						align-items: center;
						justify-content: flex-start;
						border-radius: 3px;
						background: #FEE3E2;
						box-shadow: 0px 0px 2.846874952316284px 0px rgba(0, 0, 0, 0.15), 0px 2.846874952316284px 17.081249237060547px 0px rgba(0, 0, 0, 0.15);
						padding: 25px;
						gap: 25px;
						margin: 20px 0;
						&.reqs-met {
							background: #D0F8DB;
						}
            .title {
							font-weight: 900;
            }
						.reqsIcon {
							width: 30px;
							height: 30px;
							pointer-events: none;
							flex-shrink: 0;
						}
          }
					.divider {
						height: 1px;
						background-color: #EEEEEE;
						border: none;
					}
        }
      }
    }
  }
}


.requiredIcon {
	background: radial-gradient( 50% 100%, #FFFFFF 0, #FFFFFF 34%, #FFFFFF00 35% );
}

@media only screen and ( min-width : 993px ) {
	#yp {
		.top-bar {
			.icon-toggle {
				opacity: 0;
				pointer-events: none;
			}
		}
	}
	.reqsModal {

	}
}

@media print {
	@page {
		size: landscape;
	}

	.top-bar {
		display: none;
	}

	.page {
		position: fixed;
		width: 100vw;
		height: 100vh;

		.top {
			display: none;
		}
	}

	.print-header-container {
		display: flex !important;
		flex-direction: column;
		align-items: center;

		.print-title {
			font-weight: 600;
			font-size: 22px;
		}
		.print-chosen-program {
			font-weight: 500;
		}
	}

	.your-plan-content {
		margin-top: 30px;
		width: 100%;
		height: 80%;
		grid-template-columns: repeat(4, 1fr);
		gap: 16px;
	}
}
</style>
